// getBBox doesn't work unless element is in the DOM
export function getBBox (el) {
  const clone = el.cloneNode(true);

  const tmpDiv = document.createElement('div');
  tmpDiv.setAttribute('style', 'position:absolute; visibility:hidden; width:0; height:0');
  const tmpSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  tmpSvg.appendChild(clone);
  tmpDiv.appendChild(tmpSvg);
  document.body.appendChild(tmpDiv);

  const bbox = clone.getBBox();

  document.body.removeChild(tmpDiv);
  return bbox;
}
